export default "<app-detail-cda [categoryType] = \"categoryType\" [categories] = \"categories\"></app-detail-cda>\n\n"